import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RegisterPwa } from './pwa/RegisterPwa';
import { AppRouter } from './app/AppRouter';
import { SyncProvider } from './sync/SyncContext';
import './styles/tokens.css';
import './styles/global.css';

const savedTheme = localStorage.getItem('kemi.theme');
if (savedTheme === 'light' || savedTheme === 'dark') document.documentElement.dataset.theme = savedTheme;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SyncProvider>
          <AppRouter />
          <RegisterPwa />
        </SyncProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
